module.exports = __webpack_public_path__ + "img/food8.3032e314.jpg";